import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { MatDialog } from '@angular/material/dialog';
import { HealthComponent } from '../health/health.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  navHeader = ContentPage.esES.menu;
  languageOptions = ContentPage.esES.language;
  languageCurrent: string = "esES";
  visible : boolean = false;
  routerCurrent: string = "";

  constructor(
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.navHeader = language == 'esEN' ? ContentPage.esEN.menu : ContentPage.esES.menu;
      this.languageOptions = language == 'esEN' ? ContentPage.esEN.language : ContentPage.esES.language;
      this.languageCurrent = language;
    }
    this.routerCurrent = this.router.url;
  }

  openMenu(){
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }

  changeLanguage(type){
    this.languageCurrent = type == 0 ? 'esES':'esEN';
    localStorage.setItem('language',type == 0 ? 'esES':'esEN');
    location.reload()
  }

  goTo(url){
    this.router.navigateByUrl(url)
  }

}
